import { SemiCircle } from "@components/background/semi_circle";
import { PopupError } from "@components/general/popup";
import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect, useState } from "react";
import {
  LuAlertTriangle,
  LuBookMarked,
  LuBookOpen,
  LuCalendarCheck,
  LuCalendarDays,
  LuClipboardList,
  LuCoins,
  LuCreditCard,
  LuFileBarChart,
  LuFileText,
  LuHeartPulse,
  LuSettings2,
  LuStore,
  LuTrophy,
  LuUser,
  LuWallet,
} from "react-icons/lu";
import { useNavigate } from "react-router-dom";

const MenuItem = ({
  onClick,
  bg,
  color,
  Icon,
  label,
}: {
  onClick: () => void;
  bg: string;
  color: string;
  Icon: React.ElementType;
  label: string;
}) => (
  <div className="tw-mx-2 tw-pb-2 card-grid">
    <div onClick={onClick} className="tw-m-0">
      <div
        className="tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-2 tw-rounded-full tw-w-[46px] tw-h-[46px] tw-border-2 tw-border-background-100 tw-shadow-sm"
        style={{ background: bg }}
      >
        <Icon className="tw-text-2xl" style={{ color }} />
      </div>
      <div className="tw-line-clamp-1 card-name">{label}</div>
    </div>
  </div>
);

export const MenuPage = () => {
  const navigate = useNavigate();
  const { setHeader, setAppBar, setBottomNavigation } = useThemeStore(
    (state) => state,
  );

  const [popupError, setPopupError] = useState<boolean>(false);

  useEffect(() => {
    setHeader({ buttonBack: true, filter: false, title: "Menu", image: false });
    setAppBar({ title: "Menu", show: true, leading: "back" });
    setBottomNavigation("hidden");
  }, [setHeader, setAppBar, setBottomNavigation]);

  const Section = ({ title }: { title: string }) => (
    <div className="tw-px-4 tw-mb-2 tw-mt-4">
      <div className="tw-flex tw-items-center tw-gap-2">
        <div className="tw-w-1 tw-h-4 tw-rounded-full tw-bg-primary tw-shrink-0" />
        <div className="tw-text-xs tw-font-bold tw-text-text-secondary tw-uppercase tw-tracking-widest">
          {title}
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="tw-px-4 tw-pb-20">
        <SemiCircle />
        <div className="tw-px-0 card-body">
          <Section title="Sekolah" />
          <div className="tw-mb-2">
            <div className="card-body-grid">
              <MenuItem
                onClick={() => navigate(linkPage.INFO_BIOGRAPH)}
                bg="#eff8ff"
                color="#56b6fd"
                Icon={LuUser}
                label="Biodata"
              />
              <MenuItem
                onClick={() => navigate(linkPage.HEALTH_PAGE)}
                bg="#e0f9f2"
                color="#10b981"
                Icon={LuHeartPulse}
                label="Info UKP"
              />
              <MenuItem
                onClick={() => navigate(linkPage.ABSENCE_PAGE)}
                bg="#f1f5f9"
                color="#64748b"
                Icon={LuClipboardList}
                label="Absensi"
              />
              <MenuItem
                onClick={() => navigate(linkPage.VIOLATION_PAGE)}
                bg="#ffecec"
                color="#ef4444"
                Icon={LuAlertTriangle}
                label="Pelanggaran"
              />
              <MenuItem
                onClick={() => navigate(linkPage.ACHIEVEMENT_PAGE)}
                bg="#fef3c7"
                color="#f59e0b"
                Icon={LuTrophy}
                label="Prestasi"
              />
            </div>
          </div>

          <Section title="Tahfidz" />
          <div className="tw-mb-2">
            <div className="card-body-grid">
              <MenuItem
                onClick={() => navigate("/school/tahfidz")}
                bg="#e0f9f2"
                color="#0d9488"
                Icon={LuBookOpen}
                label="Tahfidz"
              />
              <MenuItem
                onClick={() => navigate("/school/tafaquh")}
                bg="#e4e8ff"
                color="#6366f1"
                Icon={LuBookMarked}
                label="Tafaquh"
              />
            </div>
          </div>

          {/* <Section title="Toko" />
          <div className="tw-mb-2">
            <div className="card-body-grid">
              <MenuItem
                onClick={() => navigate(linkPage.MARKETPLACE_PRODUCT)}
                bg="#fff7ed"
                color="#f97316"
                Icon={LuStore}
                label="Toko"
              />
              <MenuItem
                onClick={() => navigate(linkPage.MARKETPLACE_SETTING)}
                bg="#f3f4f6"
                color="#6b7280"
                Icon={LuSettings2}
                label="Atur Limit"
              />
            </div>
          </div> */}

          {/* <Section title="Kewajiban" />
          <div className="tw-mb-2">
            <div className="card-body-grid">
              <MenuItem
                onClick={() => navigate(linkPage.MONTHLY_BILL_PAGE)}
                bg="#ffecec"
                color="#ef4444"
                Icon={LuCalendarDays}
                label="Bulanan"
              />
              <MenuItem
                onClick={() => navigate(linkPage.NON_MONTHLY_BILL_PAGE)}
                bg="#fff7ed"
                color="#f97316"
                Icon={LuFileText}
                label="Non Bulanan"
              />
            </div>
          </div> */}

          {/* <Section title="Pembayaran" />
          <div className="tw-mb-2">
            <div className="card-body-grid">
              <MenuItem
                onClick={() =>
                  navigate(
                    linkPage.FINANCE_REQUEST_VA.replace(":type", "bill"),
                    { state: { tagihan: true, tipe: "bill" } },
                  )
                }
                bg="#ecf4ff"
                color="#3b82f6"
                Icon={LuCreditCard}
                label="Request VA"
              />
              <MenuItem
                onClick={() =>
                  navigate(
                    linkPage.FINANCE_REQUEST_VA.replace(":type", "zis"),
                    { state: { tagihan: false, tipe: "zis" } },
                  )
                }
                bg="#f5f3ff"
                color="#7c3aed"
                Icon={LuCoins}
                label="VA ZIS"
              />
              <MenuItem
                onClick={() => navigate("/finance/data-va")}
                bg="#f1f5f9"
                color="#64748b"
                Icon={LuFileBarChart}
                label="Laporan VA"
              />
              <MenuItem
                onClick={() => navigate(linkPage.CHECKING_ACC_PAGE)}
                bg="#ecf4ff"
                color="#3b82f6"
                Icon={LuWallet}
                label="Laporan Uang Saku"
              />
            </div>
          </div> */}

          <Section title="Perizinan" />
          <div className="tw-mb-2">
            <div className="card-body-grid">
              {/* <MenuItem
                onClick={() => navigate(linkPage.PERMIT_PAGE)}
                bg="#ffecec"
                color="#ff6b6b"
                Icon={LuCalendarCheck}
                label="Request Izin"
              /> */}
              <MenuItem
                onClick={() => navigate(linkPage.PERMIT_DATA_PAGE)}
                bg="#f1f5f9"
                color="#64748b"
                Icon={LuClipboardList}
                label="Laporan"
              />
            </div>
          </div>
        </div>
      </div>

      <PopupError
        open={popupError}
        title="Fitur Tidak Tersedia"
        message="Fitur ini sedang dalam perbaikan. Kami akan segera mengaktifkannya kembali."
        textConfirm="Tutup"
        onConfirm={() => setPopupError(false)}
      />
    </>
  );
};
